
/**
 * New, Semantic mobile header
 */
require([
    'jquery',
    'services',
    'ch_menu',
    'ch_semantic_wishlist',
    'ch_site_notification',
    'ch_footer',
    'ch_points',
    'ch_welcome_overlay',
    'ch_semantic_search',
], function($) {
    /**
     * Set the main category button that is active
     * and make sure it is in view (for mobile users)
     *
     */
    function setCategoryMenuItemActive(mainCategoryId) {
        var $mainMenu = $('#main-menu');
        var $activeMenuItem;

        if ($mainMenu.length) {
            if (mainCategoryId) {
                $activeMenuItem = $mainMenu.find('[data-category-id=' + mainCategoryId + ']');
            } else if (CH && CH.remoteLearning) {
                // Special consideration for the remote learning browse experience
                // Which is managed through a quary param, not in the url path
                $activeMenuItem = $mainMenu.find('.js-remote-learning-nav');
            } else {
                // determine the base uri path, excluding sub/tertiary categories
                // regex splits "/nyc/classes/dance/salsa/dance-like-emilio" to:
                // [1] = "/nyc/classes/dance"
                // [2] = "/salsa"
                // [3] = "/dance-like-emilio"
                var uriSplit = window.location.pathname.split(/^(\/{0,1}[\w\d\-_]*\/{0,1}[\w\d\-_]*\/{0,1}[\w\d\-_]*)(\/{0,1}[\w\d\-_]*)/);

                if (
                    $mainMenu.length &&
                    uriSplit.length >= 2
                ) {
                    $activeMenuItem = $mainMenu.find('.item.browse[href="' + uriSplit[1] + '"]');
                }
            }

            // set the selected category menu item as "active"
            // we do this here (instead of in the markup) because the menu markup is cached
            if ($activeMenuItem.length) {
                $activeMenuItem.first().addClass('active');
                // ios safari does will scroll both x,y "into view" so we can't use this:
                // $activeMenuItem[0].scrollIntoView
                $mainMenu
                    .find('> .menu')
                    .scrollLeft($activeMenuItem[0].offsetLeft);
            }
        }
    }

    /**
     * Style elements for the mobile header(s)
     *
     * - top header
     * - category menu
     * - filter header
     * - filter nav
     * etc...
     *
     * Sets element top padding to make space for fixed elements around it
     *
     * Warning: this should be run once styles are computed (window load)
     */
    function initFixedHeaders() {
        $('[data-pad-for-fixed-element]').each(function(i, el) {
            var $this = $(el);
            var targetElSelector = $this.data('pad-for-fixed-element');
            var height = $(targetElSelector).outerHeight(true);

            $this.css({
                paddingTop: height || 0
            });
        });
    }

    function initCategoryPopups() {
        var $categories = $('.item.browse.with-popup', '#NavBar');
        $categories.each(function(index) {
            var $self = $(this);
            $self.popup({
                inline: true,
                hoverable: true,
                position: ((index/$categories.length) < .5)
                    ? 'bottom left'
                    : 'bottom right',
                distanceAway: -11,
                variation: 'basic'
            });
        });
    }

    function initHubSelector() {
        var $hubPopup = $('#different-geo-hub-alert');
        var $hubMenu = $('.hub-select');

        // make it look like a pretty dropdown
        $hubMenu.length && $hubMenu.dropdown();

        // set up hub selector popup
        if ($hubPopup.length > 0) {
            $popup = $hubMenu.popup({
                popup : $hubPopup,
                position: 'bottom center',
                on: 'manual'
            });
            $popup.popup('show');
            setTimeout(function() {
                $popup.popup('hide');
            }, 10000);
            $hubPopup.find('.close').on('click', function(e) {
                $popup.popup('hide');
            });
        }
    }

    // make the page go
    $(function() {
        if (CH && !CH.isMobile) {
            initCategoryPopups();
        }
        setCategoryMenuItemActive(CH && CH.activeMainCategoryId);
        initHubSelector();

    });
    if (CH && CH.isMobile) {
        window.onWindowLoad(function() {
            initFixedHeaders();
        });
    }
});

define("ch_header", function(){});

